import { render } from "./ProjectResult.vue?vue&type=template&id=82001e3e&scoped=true&ts=true"
import script from "./ProjectResult.ts?vue&type=script&lang=ts"
export * from "./ProjectResult.ts?vue&type=script&lang=ts"

import "./ProjectResult.scss?vue&type=style&index=0&id=82001e3e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82001e3e"]])

export default __exports__